import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import SelectInput from '../../../../../../app/common/SelectInput';
import { t } from '../../../../../infra/i18n';
export var PlatformSelector = function (_a) {
    var platforms = _a.platforms, selectedPlatform = _a.selectedPlatform, onSelectedPlatformChanged = _a.onSelectedPlatformChanged;
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "u-mt c-label-new", children: t('admin:external_platforms.import_from_label') }), _jsx("div", { children: _jsx(SelectInput, { empty: t('admin:external_platforms.select_platform_placeholder'), options: platforms, className: "c-select u-width-100", valueField: "id", textField: "name", input: {
                        onChange: onSelectedPlatformChanged,
                        value: selectedPlatform,
                    } }) })] }));
};
